import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';

const MaterialErrorIcon = (props) => {
  return <ErrorOutlineOutlinedIcon htmlColor="#FF543E" {...props} />;
};

export default MaterialErrorIcon;
